import axios from "axios"
import { toast } from './tools'
import { API_URL } from './config'
const service = axios.create({
    API_URL,
    timeout: 10000
})
// 发起请求之前的拦截器
service.interceptors.request.use(
    config => {
        const token = window.localStorage.getItem('cpstoken')
        if(token){
            config.headers = {
                'x-access-token': token
            }
        }
        return config
    },
    error => Promise.reject(error)
)
// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if(response.status !==200) {
            return Promise.reject(new Error(res.success || 'Error'))
        }else{
            if(res.code == 0){
                return res.result || res.data
            }else{
                if(res.message) {
                    toast(res.message)
                }
            }   
        }
    },
    error => {
        toast("服务器出差了，请稍后再试")
        return Promise.reject(error)
    }
)
export default service



// WEBPACK FOOTER //
// ./src/util/cps/request.js